import React from 'react';
import PropTypes from 'prop-types';

import Button from 'wonderbly-components/lib/Button';

import { replaceTextWithValues } from 'src/common/utils/text-replace';

import './StripeButton.scss';

const StripeButton = props => {
  return (
    <Button
      className="button--stripe"
      colour="green"
      onClick={props.handleOnClick}
      raised
      fullWidth
      disabled={props.disabled} >
      {props.cta ? replaceTextWithValues(props.cta, { total: props.total }) : props.total}
    </Button>
  );
};

StripeButton.propTypes = {
  total: PropTypes.string.isRequired,
  cta: PropTypes.string,
  disabled: PropTypes.bool,
  handleOnClick: PropTypes.func.isRequired,
  submittingMethod: PropTypes.string,
};

export default StripeButton;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/StripeButton/StripeButton.js